import { ISMT_CauTrucDe_Insert_Request } from "../../../model/request/de-thi/ISMT_CauTrucDe_Insert_Request";
import { ISMT_CauTrucDeThi } from "../../../model/respone/de-thi/ISMT_CauTrucDeThi";
import { ISMT_CauTrucDe_Section } from "../../../model/respone/de-thi/ISMT_CauTrucDeThi_Section";
import { ISMT_CauTrucDeThi_Select } from "../../../model/respone/de-thi/ISMT_CauTrucDeThi_Select";
import { ISMT_ChonCauHoi_Vm } from "../../../model/respone/de-thi/ISMT_ChonCauHoi_Vm";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eCauTrucDeThiActionsObj = {
  LOAD_START: {} as any,
  LOAD_SUCCESS: {} as ISMT_CauTrucDeThi_Select[],
  LOAD_ERROR: "",

  LOAD_START_CHON_CAU_HOI: {} as any,
  LOAD_SUCCESS_CHON_CAU_HOI: {} as ISMT_ChonCauHoi_Vm[],
  LOAD_ERROR_CHON_CAU_HOI: "",

  LOAD_SECTION_DATA_START: {} as any,
  LOAD_SECTION_DATA_SUCCESS: {} as ISMT_CauTrucDe_Section[],
  LOAD_SECTION_DATA_ERROR: "",
  CLEAR_SECTION_DATA: [] as any,

  SAVE_START: {} as ISMT_CauTrucDe_Insert_Request,
  SAVE_SUCCESS: {} as ISMT_CauTrucDeThi,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  DELETE_MULTIPLE_START: {} as number[],
  DELETE_MULTIPLE_SUCCESS: undefined,
  DELETE_MULTIPLE_ERROR: "",

  SELECTED_ID: [] as number[],

  SHOW_EDIT_MODAL: {} as undefined | ISMT_CauTrucDeThi,
  CLOSE_EDIT_MODAL: undefined,

  SHOW_CHON_CAU_HOI_MODAL: {} as undefined | ISMT_ChonCauHoi_Vm,
  CLOSE_CHON_CAU_HOI_MODAL: undefined,

  CHANGE_REQUEST: {} as any,
};
export const eCauTrucDeThiActionIds = generateActionTypeIds(
  eCauTrucDeThiActionsObj,
  "CAU_TRUC_DE_THI"
);
export type ICauTrucDeThiActionTypes = IGenericActionType<
  typeof eCauTrucDeThiActionsObj,
  "CAU_TRUC_DE_THI"
>;
